import {
  Component,
  ElementRef,
  HostListener,
  ViewChild,
  ViewEncapsulation,
  signal,
  inject,
  DestroyRef,
  effect,
  linkedSignal,
  QueryList,
  ViewChildren,
  AfterViewInit,
  ChangeDetectionStrategy,
  computed,
  Signal,
} from '@angular/core';
import { toSignal, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import {
  ProductTaskDetailComponent,
  TaskNavMove,
  TaskNavMoveAbilities,
} from 'src/app/components/main/shared/company-products/product-task-detail/product-task-detail.component';
import { CompanyProductPhaseBoardCol } from 'src/app/models/company_product_phase_board_col.model';
import { CompanyProductPhaseBoardColRoleDialogComponent } from './company-product-phase-board-col-role-dialog/company-product-phase-board-col-role-dialog.component';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/models/user.model';
import { CompanyProductPhaseBoard } from 'src/app/models/company_product_phase_board.model';
import { CompanyProductPhase } from 'src/app/models/company_product_phase.model';
import { ProductTaskBoard } from 'src/app/models/product_task_board.model';
import { ProductTaskBoardTimeBudget } from 'src/app/models/product_task_board_time_budget.model';
import { TaskFromTodoToProgressDialogComponent } from 'src/app/components/main/shared/company-products/company-product-phase-board-column-changes/task-from-todo-to-progress-dialog/task-from-todo-to-progress-dialog.component';
import { TaskToDeadlockDialogComponent } from 'src/app/components/main/shared/company-products/company-product-phase-board-column-changes/task-to-deadlock-dialog/task-to-deadlock-dialog.component';
import { WorkingTimeCategory } from 'src/app/models/working_time_category.model';
import { MatTooltip } from '@angular/material/tooltip';
import { MatChip } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem, MatMenuContent } from '@angular/material/menu';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgClass } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatInput } from '@angular/material/input';
import { SecondsToStringTimePipe } from 'src/app/pipes/seconds-to-string-time.pipe';
import { ProductTaskTypeImagePipe } from 'src/app/pipes/product-task-type-image.pipe';
import { SecondsToHourStringPipe } from 'src/app/pipes/seconds-to-hour-string.pipe';
import { SecondsToHourWithDecimalPipe } from 'src/app/pipes/seconds-to-hour-with-decimal.pipe';
import { PriorityImgPipe } from 'src/app/pipes/priority-img.pipe';
import { CreateProductTaskDialogComponent } from 'src/app/components/main/shared/company-products/create-product-task-dialog/create-product-task-dialog.component';
import { PRODUCT_TASK_STORY_TASK_MUST_BE_CREATED_IN_BACKLOG_TOOLTIP } from 'src/app/constants/product-task-product-trio-restrictions.constants';
import { ProductTaskTypeEnum } from 'src/app/enums/product-task-type.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ArrayResponse } from 'src/app/models/array_response.interface';
import { ProductTaskDeclineReason } from 'src/app/models/product_task_decline_reason';
import { CheckboxSelectorDialogComponent } from 'src/app/components/main/shared/checkbox-selector-dialog/checkbox-selector-dialog.component';
import { Subject, Observable, of, combineLatest, forkJoin } from 'rxjs';
import { switchMap, map, distinctUntilChanged } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';
import { UtilsService } from 'src/app/services';
import { ProductTask } from 'src/app/models/product_task.model';
import {
  CompanyProductPhaseUserPermissions,
  EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS,
} from 'src/app/interfaces/company-product-phase-user-permissions.interface';
import { CompanyProductGithubPullRequestLinkComponent } from 'src/app/components/main/shared/company-products/company-product-github-pull-request-link/company-product-github-pull-request-link.component';

export interface Columns {
  column: CompanyProductPhaseBoardCol;
  product_task_boards: ProductTaskBoardCustom[];
}

@Component({
  selector: 'app-company-product-phase-board-detail',
  templateUrl: './company-product-phase-board-detail.component.html',
  styleUrls: ['./company-product-phase-board-detail.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CdkDropList,
    CdkDrag,
    CdkDragHandle,
    MatTooltip,
    MatChip,
    MatIcon,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatMenuContent,
    FormsModule,
    MatProgressSpinner,
    NgClass,
    MatFormField,
    MatSelect,
    MatOption,
    MatCheckbox,
    MatButton,
    MatInput,
    SecondsToStringTimePipe,
    ProductTaskTypeImagePipe,
    SecondsToHourStringPipe,
    SecondsToHourWithDecimalPipe,
    PriorityImgPipe,
    ReactiveFormsModule,
    CompanyProductGithubPullRequestLinkComponent,
  ],
})
export class CompanyProductPhaseBoardDetailComponent implements AfterViewInit {
  protected activatedRoute = inject(ActivatedRoute);
  protected router = inject(Router);
  private dialog = inject(MatDialog);
  private api = inject(ApiService);
  private userService = inject(UserService);
  private fb = inject(FormBuilder);
  private snack = inject(MatSnackBar);
  private destroy_ref = inject(DestroyRef);
  private utils = inject(UtilsService);

  creatingColumn: boolean = false;
  creatingTask: boolean = false;
  creatingTaskColumnId: any = null;
  creatingTaskSelectedType: ProductTaskTypeEnum = ProductTaskTypeEnum.ISSUE;
  creatingTaskIsHotfix: boolean = false;
  creatingTaskNeedsTesting: boolean = false;
  creatingTaskName: string = '';
  hoveringColumnId: any = null;
  hoveringTaskId: any = null;
  newColumnName: string = '';
  dialogAlreadyOpened: boolean = false;

  mode: 'all' | 'assigned' | 'listening' = 'all';

  editingColumnTitleId: any = null;
  editingColumnTitle: any = null;
  user: User | null = null;
  phase = signal<CompanyProductPhase | null>(null);
  readonly user_permissions: Signal<CompanyProductPhaseUserPermissions> = toSignal(
    this.activatedRoute.params.pipe(
      map(() => {
        this.initRouteParameters();
        return this.phase_id;
      }),
      distinctUntilChanged(),
      switchMap(phaseId =>
        phaseId ? this.api.getCompanyProductPhaseUserPermissions(phaseId) : of(EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS)
      )
    ),
    { initialValue: EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS }
  );

  filterForm: UntypedFormGroup;

  private board_id: number;
  private phase_id: number;
  protected company_product_id: number;
  private hasOpenedTaskFromParams: boolean = false;
  private refreshBoardTrigger = signal(0);
  private with_string: string =
    'product_task..tags,product_task..company_product_epic,product_task..product_task_listeners,product_task_board_time_budgets..budgetable,product_task_board_time_budgets..assignee,active_product_task_board_time_budget..assignee,active_product_task_board_time_budget..budgetable';

  private board_raw_data = toSignal(
    combineLatest([
      this.activatedRoute.params,
      this.activatedRoute.queryParams.pipe(
        map((params: Params): { board_key: string; params: Params } => ({
          board_key: `${params['mode'] ?? 'all'}`,
          params,
        })),
        distinctUntilChanged((a, b) => a.board_key === b.board_key)
      ),
      toObservable(this.refreshBoardTrigger),
    ]).pipe(
      switchMap(([, { params: queryParams }]) => {
        this.initRouteParameters();
        this.mode = (queryParams['mode'] != null ? (queryParams['mode'] ?? 'all') : 'all') as 'all' | 'assigned' | 'listening';

        const params: any = {
          with: this.with_string,
        };
        params['where_has_product_task'] = true;
        params['product_task-is_archived'] = false;
        return this.api.getCompanyProductPhaseBoardStructure(this.board_id, params);
      })
    ),
    { initialValue: null }
  );

  data = linkedSignal({
    source: this.board_raw_data,
    computation: (raw): { company_product_phase_board: CompanyProductPhaseBoard; columns: Columns[] } | null => {
      if (!raw) return null;
      const boardDataTyped = raw as {
        company_product_phase_board: CompanyProductPhaseBoard;
        columns: { column: CompanyProductPhaseBoardCol; product_task_boards: ProductTaskBoard[] }[];
      };
      const result: { company_product_phase_board: CompanyProductPhaseBoard; columns: Columns[] } = {
        company_product_phase_board: boardDataTyped.company_product_phase_board,
        columns: boardDataTyped.columns.map(column => ({
          column: column.column,
          product_task_boards: column.product_task_boards as ProductTaskBoardCustom[],
        })),
      };
      result.columns.forEach(column => {
        column.product_task_boards = column.product_task_boards
          .filter(ptb => this.filterByMode(ptb))
          .map(ptb => this.productTaskBoardToCustom(ptb, result));
      });
      return result;
    },
  });

  column_names = computed((): string[] => this.data()?.columns.map((column: Columns): string => column.column.title) ?? []);

  public draggingOriginSlug: string | null = null;
  draggingOriginIsDevPending = false;
  draggingBoard: ProductTaskBoard | null = null;

  static dialog: any;

  protected readonly ProductTaskTypeEnum = ProductTaskTypeEnum;
  readonly boardStoryTaskDisabledTooltip = PRODUCT_TASK_STORY_TASK_MUST_BE_CREATED_IN_BACKLOG_TOOLTIP;
  can_create_tasks_on_board = computed<boolean>((): boolean => {
    return this.user_permissions().can_edit_board && !this.utils.isCompanyProductPhaseBoardPast(this.data()?.company_product_phase_board);
  });

  saved_scroll_positions: Record<string, number> = {};

  //Autofocus on new task when creating
  @ViewChild('creatingTaskInput', { static: false })
  set creatingTaskInput(element: ElementRef<HTMLTextAreaElement>) {
    if (element) {
      element.nativeElement.focus();
    }
  }

  @ViewChildren('columnList')
  column_lists!: QueryList<ElementRef<HTMLDivElement>>;

  //Close creating task on press ESC
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: Event) {
    if (!(event instanceof KeyboardEvent)) return;
    this.closeCreateTask();
  }

  constructor() {
    this.filterForm = this.fb.group({
      show_archived_boards: [
        this.activatedRoute.snapshot.queryParamMap.get('show_archived_boards') != null
          ? this.activatedRoute.snapshot.queryParamMap.get('show_archived_boards') == 'true'
          : false,
      ],
      mode: [
        this.activatedRoute.snapshot.queryParamMap.get('mode') != null ? this.activatedRoute.snapshot.queryParamMap.get('mode') : 'all',
      ],
    });

    this.canMoveColumns = this.canMoveColumns.bind(this);

    // Initialize route parameters first
    this.initRouteParameters();

    // Setup user signal sync
    const userData = toSignal(this.userService.currentUser, { initialValue: null });
    effect(() => {
      this.user = userData();
    });

    // Setup phase signal - reactive to route params
    const phaseData = toSignal(
      this.activatedRoute.params.pipe(
        map(() => {
          this.initRouteParameters();
          return this.phase_id;
        }),
        distinctUntilChanged(),
        switchMap(phaseId =>
          phaseId
            ? forkJoin({
                phase: this.api.getCompanyProductPhase(phaseId),
                epics: this.api.getCompanyProductEpics(phaseId),
              }).pipe(
                map(({ phase, epics }) => ({
                  ...phase,
                  company_product_epics: epics,
                }))
              )
            : of(null)
        )
      ),
      { initialValue: null }
    );
    effect(() => {
      this.phase.set(phaseData());
    });

    // React to selectedIssue in URL with toSignal + effect so opening task does not trigger board refetch (preserves column scroll)
    const selectedIssueFromParams = toSignal(this.activatedRoute.queryParamMap.pipe(map(m => m.get('selectedIssue'))), {
      initialValue: this.activatedRoute.snapshot.queryParamMap.get('selectedIssue') ?? null,
    });
    effect(() => {
      const issue = selectedIssueFromParams();
      const permissions = this.user_permissions();
      // Wait until phase permissions are loaded — EMPTY is only the toSignal placeholder.
      const permissions_ready = permissions !== EMPTY_COMPANY_PRODUCT_PHASE_USER_PERMISSIONS;
      if (issue && !this.hasOpenedTaskFromParams && permissions_ready) {
        this.hasOpenedTaskFromParams = true;
        this.openTask(issue);
      } else if (!issue) {
        this.hasOpenedTaskFromParams = false;
      }
    });
  }

  isEndingDateBiggerThanToday(date: Date) {
    const today = new Date();
    const endingDate = new Date(date);
    return endingDate > today;
  }

  private initRouteParameters() {
    this.board_id = +((this.activatedRoute.snapshot.paramMap.get('board_id') ??
      this.activatedRoute.parent?.snapshot.paramMap.get('board_id') ??
      this.activatedRoute.parent?.parent?.snapshot.paramMap.get('board_id')) as string);
    this.company_product_id = +((this.activatedRoute.snapshot.paramMap.get('company_product_id') ??
      this.activatedRoute.parent?.snapshot.paramMap.get('company_product_id') ??
      (this.activatedRoute.parent?.parent?.snapshot.paramMap.get('company_product_id') as string) ??
      this.activatedRoute.parent?.parent?.parent?.snapshot.paramMap.get('company_product_id')) as string);
    this.phase_id = +((this.activatedRoute.snapshot.paramMap.get('phase_id') ??
      this.activatedRoute.parent?.snapshot.paramMap.get('phase_id') ??
      this.activatedRoute.parent?.parent?.snapshot.paramMap.get('phase_id')) as string);
  }

  dropGridOnColumnOrderChange(event: CdkDragDrop<string[]>): void {
    const data = this.data();
    if (!data) return;
    if (event.previousIndex != event.currentIndex) {
      moveItemInArray(data.columns, event.previousIndex, event.currentIndex);
      this.changeColumnOrder(data.columns);
    }
  }

  canMoveColumns(item: CdkDrag, list: CdkDropList): boolean {
    return this.user_permissions().can_edit_board;
  }

  editColumn(column: any) {
    if (this.user_permissions().can_edit_board) {
      this.editingColumnTitleId = column.column.id;
      this.editingColumnTitle = column.column.title;
    }
  }

  isWorkingTimeCategoryUnderReview(time_budget: ProductTaskBoardTimeBudgetCustom): boolean {
    return (
      time_budget.budgetable_type === 'App\\Models\\WorkingTimeCategory' &&
      (time_budget.budgetable as WorkingTimeCategory).slug === 'review-task'
    );
  }

  async dropTask(event: CdkDragDrop<ProductTaskBoardCustom[]>) {
    if (event.previousContainer === event.container) {
      if (event.previousIndex !== event.currentIndex) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        this.changeColumnTasksOrder(event.container);
      }
    } else {
      const new_column_id = +(event.container.element.nativeElement.getAttribute('data-column-id') as string);
      const old_column_id = +(event.previousContainer.element.nativeElement.getAttribute('data-column-id') as string);
      const product_task_board_id = +(event.item.element.nativeElement.getAttribute('data-product-task-board-id') as string);
      const product_task_id = event.item.element.nativeElement.getAttribute('data-product-task-id');
      const newIndex = event.currentIndex;

      const data = this.data();
      if (!data) return;
      const colDestination: CompanyProductPhaseBoardCol = data.columns.find((col: Columns) => col.column.id == new_column_id)!.column;
      const colOrigin: CompanyProductPhaseBoardCol = data.columns.find((col: Columns) => col.column.id == old_column_id)!.column;
      const product_task_board: ProductTaskBoard = this.findProductTaskBoardOnStructure(product_task_board_id) as ProductTaskBoard;

      if (product_task_board_id != null && product_task_id != null) {
        const result = await CompanyProductPhaseBoardDetailComponent.checkAndAskIfTaskMoveIsValid(
          product_task_board,
          colOrigin,
          colDestination,
          this.api,
          this.dialog,
          this.user!.id
        );
        if (result.valid) {
          transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
          event.container.data[event.currentIndex].company_product_phase_board_col_id = new_column_id;
          this.moveTaskFromColumnToColumn(
            product_task_board_id,
            colDestination,
            colOrigin,
            newIndex,
            +product_task_id,
            result.decline_reasons
          );
        }
      }
    }
  }

  fetchBoard() {
    this.saveScrollPositions();
    // Trigger refresh by updating the refresh trigger signal
    this.refreshBoardTrigger.update(v => v + 1);
  }

  private changeColumnOrder(columns: Columns[]) {
    const columnsOrder = columns.map((column: any) => column.column.id);
    this.api.changeBoardColumnsOrder(this.board_id, columnsOrder).pipe(takeUntilDestroyed(this.destroy_ref)).subscribe();
  }

  private changeColumnTasksOrder(column: any) {
    const tasksOrder = column.data.map((task: any) => task.id);
    this.api.changeBoardColumnTasksOrder(this.board_id, tasksOrder).pipe(takeUntilDestroyed(this.destroy_ref)).subscribe();
  }

  private moveTaskFromColumnToColumn(
    product_task_board_id: number,
    colDestination: CompanyProductPhaseBoardCol,
    colOrigin: CompanyProductPhaseBoardCol,
    newIndex: number,
    product_task_id: number,
    decline_reasons: number[] | null = null
  ) {
    this.api
      .moveTaskFromColumnToColumn(this.board_id, product_task_board_id, colDestination, newIndex, decline_reasons, {
        with: this.with_string,
        append: 'ro_time_registered',
      })
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((data: ProductTaskBoard) => {
        const current_data = this.data();
        const dialog_result$ = current_data
          ? CompanyProductPhaseBoardDetailComponent.handleTaskFromColumnToColumnDialogs(
              this.dialog,
              product_task_board_id,
              colOrigin,
              colDestination,
              this.company_product_id,
              product_task_id,
              current_data
            )
          : undefined;

        if (dialog_result$) {
          dialog_result$.pipe(takeUntilDestroyed(this.destroy_ref)).subscribe((dialog_data: ProductTaskBoard) => {
            this.findAndUpdateProductTaskBoardOnStructure(this.productTaskBoardToCustom(dialog_data));
          });
        } else {
          this.findAndUpdateProductTaskBoardOnStructure(this.productTaskBoardToCustom(data));
        }
      });
  }

  createColumn() {
    this.creatingColumn = true;
    const column = {
      title: this.newColumnName,
      company_product_phase_board_id: this.board_id,
    };
    this.api
      .createBoardColumn(column)
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((): void => {
        this.creatingColumn = false;
        this.newColumnName = '';
        this.fetchBoard();
      });
  }

  async copyColumn(col: any) {
    const product_task_boards = col.product_task_boards;
    if (!Array.isArray(product_task_boards) || product_task_boards.length === 0) {
      this.snack.open('No hay tareas para copiar!', 'Ok', { duration: 3000 });
      return;
    } else {
      let text = '';

      product_task_boards.forEach(board => {
        const task = board.product_task;
        if (task) {
          const code = task.code || ' ';
          const title = task.title || ' ';
          text += `${code}: ${title}\n`;
        }
      });

      if (text) {
        await this.utils.copyTextToClipboard(text);
        this.snack.open('Columna copiada correctamente!', 'Ok', { duration: 3000 });
      }
    }
  }

  sortColumnTasksByBacklogOrder(column: Columns) {
    if (!this.user_permissions().can_act_as_product_manager || column.product_task_boards.length <= 1) {
      return;
    }

    column.product_task_boards = [...column.product_task_boards].sort((taskA, taskB) => {
      const taskAOrder = taskA.product_task?.order_company_product_phase ?? Number.MAX_SAFE_INTEGER;
      const taskBOrder = taskB.product_task?.order_company_product_phase ?? Number.MAX_SAFE_INTEGER;

      if (taskAOrder === taskBOrder) {
        return taskA.id - taskB.id;
      }

      return taskAOrder - taskBOrder;
    });

    this.changeColumnTasksOrder({ data: column.product_task_boards });
  }

  deleteColumn(column: any) {
    if (confirm(`¿Estás seguro que quieres eliminar la columna "${column.title}"?`)) {
      this.api
        .deleteBoardColumn(column.id)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe((): void => {
          this.fetchBoard();
        });
    }
  }

  archiveTasksFromColumn(column: Columns): void {
    if (!confirm(`¿Estás seguro que quieres archivar todas las tareas de la columna "${column.column.title}"?`)) {
      return;
    }

    this.api.archiveTasks({ company_product_phase_board_col_id: column.column.id, new_status_archived: true }).subscribe((): void => {
      this.fetchBoard();
    });
  }

  deleteTask(task: ProductTaskBoardCustom) {
    if (confirm(`¿Estás seguro que quieres eliminar la tarea "${task.product_task.title}" de este tablero?`)) {
      this.api
        .deleteProductTaskBoard(task.id)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe((): void => {
          this.removeProductTaskBoardFromStructure(task.product_task.code);
        });
    }
  }

  editColumnName() {
    if (this.editingColumnTitle.length >= 3) {
      const column = {
        title: this.editingColumnTitle,
        id: this.editingColumnTitleId,
      };
      this.api
        .updateBoardColumn(column)
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe((): void => {
          this.editingColumnTitleId = null;
          this.editingColumnTitle = '';
          this.fetchBoard();
        });
    }
  }

  initCreateTask(column: any) {
    if (!this.can_create_tasks_on_board()) {
      return;
    }
    this.creatingTask = true;
    this.creatingTaskColumnId = column.id;
  }

  closeCreateTask() {
    this.creatingTask = false;
    this.creatingTaskColumnId = null;
    this.creatingTaskSelectedType = ProductTaskTypeEnum.ISSUE;
    this.creatingTaskIsHotfix = false;
    this.creatingTaskNeedsTesting = false;
    this.creatingTaskName = '';
  }

  createTask() {
    if (!this.can_create_tasks_on_board()) {
      return;
    }
    if (this.creatingTaskName.length > 2) {
      const dialogRef = this.dialog.open(CreateProductTaskDialogComponent, {
        width: '600px',
        data: {
          title: this.creatingTaskName,
          type: this.user_permissions().can_only_create_issues ? ProductTaskTypeEnum.ISSUE : this.creatingTaskSelectedType,
          company_product_phase_board_id: this.board_id,
          company_product_phase_id: this.phase_id,
          company_product_id: this.company_product_id,
          is_hotfix: this.creatingTaskIsHotfix,
          needs_testing: this.creatingTaskNeedsTesting,
          allowed_task_types: this.user_permissions().can_only_create_issues ? [ProductTaskTypeEnum.ISSUE] : undefined,
          board_only_issue_message: this.boardStoryTaskDisabledTooltip,
        },
      });
      dialogRef
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe((task: ProductTask) => {
          if (task) {
            const new_task_board: ProductTaskBoard | undefined = task.product_task_boards.values().next().value;
            if (new_task_board != undefined) {
              this.createProductTaskBoardOnStructure(this.productTaskBoardToCustom(new_task_board));
            }

            this.creatingTask = false;
            this.creatingTaskName = '';
            this.creatingTaskColumnId = null;
          }
        });
    }
  }

  displayTaskDetail($event: any, task: ProductTaskBoard) {
    $event.preventDefault();
    const eventId = this.getAttributeIdFromEvent($event);
    if (eventId != 'task-menu' && eventId != 'task-menu-icon') {
      this.setRouteParamsAndOpenTask(task.product_task.code);
    }
  }

  private async setRouteParamsAndOpenTask(task_code: string, comes_from_move: TaskNavMove | null = null): Promise<void> {
    const queryParams: Params = { selectedIssue: task_code };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      queryParamsHandling: 'merge',
    });

    this.openTask(task_code, comes_from_move);
  }

  private async openTask(task_code: string, comes_from_move: TaskNavMove | null = null) {
    const backdropSignal$ = new Subject<void>();

    if (!this.dialogAlreadyOpened) {
      this.dialogAlreadyOpened = true;
      const task_nav_move_abilities: TaskNavMoveAbilities = this.getTaskNavMoveAbilitiesInCurrentBoard(task_code);
      const dialogRef = this.dialog.open(ProductTaskDetailComponent, {
        disableClose: true,
        width: '1150px',
        maxHeight: '90vh',
        autoFocus: false,
        data: {
          task_code_id: task_code,
          company_product_phase_board_id: this.board_id,
          company_product_id: this.company_product_id,
          company_product_phase_id: this.phase_id,
          backdropSignal$: backdropSignal$,
          company_product_phase: this.phase() ?? undefined,
          company_product_epics: this.phase()?.company_product_epics,
          current_board: this.data()?.company_product_phase_board,
          user_permissions: this.user_permissions(),
          task_nav_move_abilities,
          comes_from_move,
        },
      });

      dialogRef
        .backdropClick()
        .pipe(takeUntilDestroyed(this.destroy_ref))
        .subscribe(() => {
          backdropSignal$.next();
        });

      const returned_value_from_promise = await dialogRef.afterClosed().toPromise();
      this.dialogAlreadyOpened = false;

      // Si el task board fue eliminado, quitarlo del array local sin hacer fetchBoard
      if (returned_value_from_promise && returned_value_from_promise.deleted === true) {
        this.removeProductTaskBoardFromStructure(task_code);
        this.router.navigate([], {
          queryParams: {
            selectedIssue: null,
          },
          queryParamsHandling: 'merge',
        });
        return;
      }

      const current_task_board = this.findProductTaskBoardOnStructure(task_code);

      if (returned_value_from_promise && returned_value_from_promise.task_nav_move && current_task_board) {
        this.goToTaskFromCurrent(current_task_board, returned_value_from_promise.task_nav_move);
      }

      if (current_task_board != undefined) {
        const updated_task: ProductTaskBoard | undefined = await this.api
          .getProductTaskBoard(current_task_board.id, {
            with: this.with_string,
            append: 'ro_time_registered',
          })
          .toPromise();
        if (updated_task) {
          this.findAndUpdateProductTaskBoardOnStructure(this.productTaskBoardToCustom(updated_task));
        } else this.fetchBoard();
      } else this.fetchBoard();

      if (!returned_value_from_promise || !returned_value_from_promise.task_nav_move) {
        this.router.navigate([], {
          queryParams: {
            selectedIssue: null,
          },
          queryParamsHandling: 'merge',
        });
      }
    }
  }

  saveScrollPositions(): void {
    this.column_lists.forEach(columnList => {
      this.saved_scroll_positions[columnList.nativeElement.id] = columnList.nativeElement.scrollTop;
    });
  }

  restoreScrollPositions(): void {
    this.column_lists.forEach(columnList => {
      columnList.nativeElement.scrollTop = this.saved_scroll_positions[columnList.nativeElement.id] ?? 0;
    });
  }

  ngAfterViewInit(): void {
    this.column_lists.changes.pipe(takeUntilDestroyed(this.destroy_ref)).subscribe((): void => {
      this.restoreScrollPositions();
    });
  }

  private getAttributeIdFromEvent(event: any) {
    const target = event.target || event.srcElement || event.currentTarget;
    const idAttr = target?.attributes?.id;
    const value = idAttr ? idAttr.nodeValue : null;
    return value;
  }

  allTasksArchived(column: any) {
    return column.product_tasks.filter((task: any) => !task.is_archived).length == 0;
  }

  archiveTask(task: ProductTaskBoard): void {
    this.api.archiveTasks({ tasks_ids: [task.product_task.id], new_status_archived: !task.product_task.is_archived }).subscribe(() => {
      this.removeProductTaskBoardFromStructure(task.product_task.code);
    });
  }

  changeRoleColumn(column: CompanyProductPhaseBoardCol) {
    const dialogRef = this.dialog.open(CompanyProductPhaseBoardColRoleDialogComponent, {
      width: '650px',
      data: {
        companyProductPhaseBoardCol: column,
        phase_id: this.phase_id,
      },
    });

    dialogRef
      .afterClosed()
      .toPromise()
      .then((): void => {
        this.fetchBoard();
      });
  }

  getPtbtbProgressSpinnerValue(ptbtb: ProductTaskBoardTimeBudgetCustom): number {
    if (ptbtb.time_in_seconds != null && ptbtb.time_in_seconds >= 0) {
      const prcnt = ptbtb.ro_time_registered / ptbtb.time_in_seconds;
      if (prcnt > 1) return 100;
      else return prcnt * 100;
    } else return 100;
  }

  getPtbtbProgressSpinnerClass(ptbtb: ProductTaskBoardTimeBudgetCustom, ptb: ProductTaskBoardCustom): any {
    const completed: boolean = ptbtb.completed_by_user_id != null;
    const active: boolean =
      ptb.active_product_task_board_time_budget_id != null && ptb.active_product_task_board_time_budget_id == ptbtb.id;

    return {
      disabled: !completed && !active,
      inprogress: !completed && active,
      finished: completed && (ptbtb.time_in_seconds == null || ptbtb.ro_time_registered <= ptbtb.time_in_seconds),
      overtime: completed && ptbtb.time_in_seconds != null && ptbtb.ro_time_registered > ptbtb.time_in_seconds,
    };
  }

  getPtbProgressSpinnerValue(ptb: ProductTaskBoardCustom): number {
    if (ptb.ro_time_estimation != null && ptb.ro_time_estimation >= 0) {
      const prcnt = ptb.ro_time_registered / ptb.ro_time_estimation;
      if (prcnt > 1 || prcnt == 0) return 100;
      else return prcnt * 100;
    } else return 100;
  }

  getPtbProgressSpinnerClass(ptb: ProductTaskBoardCustom, column: CompanyProductPhaseBoardCol): any {
    return {
      disabled: ptb.ro_time_estimation <= 0,
      start:
        ptb.ro_time_estimation > 0 &&
        ptb.ro_time_registered <= ptb.ro_time_estimation &&
        (column.company_product_phase_board_col_role == null ||
          !['test', 'done'].includes(column.company_product_phase_board_col_role.slug)) &&
        ptb.ro_time_registered == 0,
      inprogress:
        ptb.ro_time_estimation > 0 &&
        ptb.ro_time_registered <= ptb.ro_time_estimation &&
        (column.company_product_phase_board_col_role == null ||
          !['test', 'done'].includes(column.company_product_phase_board_col_role.slug)) &&
        ptb.ro_time_registered > 0,
      finished:
        ptb.ro_time_estimation > 0 &&
        ptb.ro_time_registered <= ptb.ro_time_estimation &&
        column.company_product_phase_board_col_role != null &&
        ['test', 'done'].includes(column.company_product_phase_board_col_role.slug),
      overtime: ptb.ro_time_estimation > 0 && ptb.ro_time_registered > ptb.ro_time_estimation,
    };
  }

  public static isProductTaskBoardDragDisabled(
    item: ProductTaskBoard,
    column: CompanyProductPhaseBoardCol,
    me: User,
    company_product_phase: CompanyProductPhase,
    company_product_phase_board: CompanyProductPhaseBoard,
    can_drag_in_board: boolean,
    can_edit_board: boolean
  ): boolean {
    if (UtilsService.isCompanyProductPhaseBoardPast(company_product_phase_board)) {
      return true;
    }

    if (can_drag_in_board) {
      const rev_budget = item.product_task_board_time_budgets.find(
        bud => bud.budgetable_type === 'App\\Models\\WorkingTimeCategory' && (bud.budgetable as WorkingTimeCategory).slug === 'review-task'
      );
      if (
        // compleix les regles d'estimació?
        column.company_product_phase_board_col_role != null &&
        column.company_product_phase_board_col_role.slug === 'todo' &&
        ((item.product_task.type === 'story' &&
          company_product_phase.needs_hours_story &&
          (item.ro_time_estimation == null || item.ro_time_estimation == 0)) ||
          (item.product_task.type === 'task' &&
            company_product_phase.needs_hours_task &&
            (item.ro_time_estimation == null || item.ro_time_estimation == 0)) ||
          (item.product_task.type === 'issue' &&
            company_product_phase.needs_hours_issue &&
            (item.ro_time_estimation == null || item.ro_time_estimation == 0)))
      ) {
        return true;
      } else if (
        column.company_product_phase_board_col_role != null &&
        // Tots els que estiguin a la columna To Do, es podran moure
        column.company_product_phase_board_col_role.slug !== 'todo' &&
        // Tots els que estiguin a la columna Deadlock, es podran moure
        column.company_product_phase_board_col_role.slug !== 'deadlock' &&
        // Si tinc els permissos a nivell de board en funció del meu rol al projecte, podré moure-ho
        !can_edit_board &&
        // Si el budget actiu està assignat a mi, el podré moure
        (item.active_product_task_board_time_budget == null ||
          (item.active_product_task_board_time_budget.assignee_id != null &&
            item.active_product_task_board_time_budget.assignee_id != me.id)) &&
        // Si està en revisió, i el budget de revisió està assignat a mi, el podré moure
        rev_budget &&
        rev_budget.assignee_id != null &&
        rev_budget.assignee_id != me.id
      ) {
        return true;
      } else return false; // activem el drag
    } else return true;
  }

  isBoardTaskTypeDisabled(type: ProductTaskTypeEnum): boolean {
    return this.user_permissions().can_only_create_issues && type !== ProductTaskTypeEnum.ISSUE;
  }

  private productTaskBoardToCustom(
    product_task_board: ProductTaskBoard,
    boardData: { company_product_phase_board: CompanyProductPhaseBoard; columns: Columns[] } | null = this.data()
  ): ProductTaskBoardCustom {
    const ptb = { ...product_task_board } as ProductTaskBoardCustom;
    ptb.ro_time_registered = product_task_board.ro_time_registered ?? 0;
    ptb.product_task_board_time_budgets = ptb.product_task_board_time_budgets.map(ptbtb => ({
      ...ptbtb,
      ro_time_registered: ptbtb.ro_time_registered ?? 0,
    }));
    if (ptb.active_product_task_board_time_budget != null) {
      ptb.active_product_task_board_time_budget = {
        ...ptb.active_product_task_board_time_budget,
        ro_time_registered: ptb.active_product_task_board_time_budget.ro_time_registered ?? 0,
      };
    }

    if (!boardData) return ptb;
    const column: CompanyProductPhaseBoardCol | undefined = boardData.columns
      .map((c: Columns) => c.column)
      .find((c: CompanyProductPhaseBoardCol) => c.id === ptb.company_product_phase_board_col_id);
    const currentPhase = this.phase();
    if (!column || !this.user || !currentPhase) {
      ptb.can_drag = false;
      ptb.can_archive_or_delete = false;
      return ptb;
    }

    ptb.can_archive_or_delete =
      this.user_permissions().can_archive_or_delete_tasks ||
      (this.user_permissions().can_create_tasks_on_backlog && ptb.product_task?.is_draft && ptb.product_task?.creator_id === this.user.id);

    ptb.can_drag = !CompanyProductPhaseBoardDetailComponent.isProductTaskBoardDragDisabled(
      ptb,
      column,
      this.user,
      currentPhase,
      boardData.company_product_phase_board,
      this.user_permissions().can_drag_in_board,
      this.user_permissions().can_edit_board
    );
    return ptb;
  }

  private static isUserAssignedToActiveBudget(ptb: ProductTaskBoard, userId: number): boolean {
    if (!ptb.active_product_task_board_time_budget_id || !ptb.product_task_board_time_budgets) {
      return false;
    }

    const activeBudget = ptb.product_task_board_time_budgets.find((ptbtb: ProductTaskBoardTimeBudget): boolean => {
      return ptbtb.id === ptb.active_product_task_board_time_budget_id;
    });

    if (!activeBudget) {
      return false;
    }

    return activeBudget.assignee_id != null && activeBudget.assignee_id === userId;
  }

  public static async checkAndAskIfTaskMoveIsValid(
    product_task_board: ProductTaskBoard,
    colOrigin: CompanyProductPhaseBoardCol,
    colDestination: CompanyProductPhaseBoardCol,
    api: ApiService,
    dialog: MatDialog,
    userId: number
  ): Promise<{ valid: boolean; decline_reasons: Array<number> | [] }> {
    if (
      colOrigin.company_product_phase_board_col_role != null &&
      colDestination.company_product_phase_board_col_role != null &&
      colOrigin.id != colDestination.id
    ) {
      if (
        colOrigin.company_product_phase_board_col_role.slug === 'under-review' &&
        ['test', 'done'].includes(colDestination.company_product_phase_board_col_role.slug)
      ) {
        const budgets_pending: ProductTaskBoardTimeBudget[] = product_task_board.product_task_board_time_budgets.filter(
          time_budget =>
            time_budget.id &&
            time_budget.completed_by_user_id == null &&
            (product_task_board.active_product_task_board_time_budget_id == null ||
              time_budget.id != product_task_board.active_product_task_board_time_budget_id) &&
            (time_budget.budgetable_type === 'App\\Models\\CompanyProductTeam' ||
              (time_budget.budgetable as WorkingTimeCategory).slug != 'review-task')
        );

        if (budgets_pending.length) {
          const confirmed = confirm(
            `Aún queda trabajo por realizar en este sprint de "${budgets_pending.map(b => b.budgetable.name).join(', ')}" que no se ha marcado como completado. ¿Estás seguro que quieres mover la tarea a "${colDestination.title}"?`
          );
          return { valid: confirmed, decline_reasons: [] };
        }
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'under-review' &&
        colDestination.company_product_phase_board_col_role.slug === 'in-progress'
      ) {
        if (CompanyProductPhaseBoardDetailComponent.isUserAssignedToActiveBudget(product_task_board, userId)) {
          return { valid: true, decline_reasons: [] };
        }

        const activeBudget = product_task_board.product_task_board_time_budgets.find(
          budget => budget.id === product_task_board.active_product_task_board_time_budget_id
        );

        const activeBudgetWorkingTimeCategory = activeBudget ? (activeBudget.budgetable as WorkingTimeCategory) : null;

        const declinedMessages: ArrayResponse<ProductTaskDeclineReason> | undefined =
          await CompanyProductPhaseBoardDetailComponent.fetchDeclineReasons(api, activeBudgetWorkingTimeCategory?.id ?? null);
        if (declinedMessages) {
          const selectedReasons = await CompanyProductPhaseBoardDetailComponent.askReasonRejection(dialog, declinedMessages.data);
          return { valid: selectedReasons.length > 0 ? true : false, decline_reasons: selectedReasons };
        }
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'under-review' &&
        colDestination.company_product_phase_board_col_role.slug === 'todo'
      ) {
        const confirmed = confirm('¿Quieres marcar la tarea como aceptada pero que aun le falta trabajo por hacer?');
        return { valid: confirmed, decline_reasons: [] };
      }
    }

    return { valid: true, decline_reasons: [] };
  }

  public static handleTaskFromColumnToColumnDialogs(
    dialog: MatDialog,
    product_task_board_id: number,
    colOrigin: CompanyProductPhaseBoardCol,
    colDestination: CompanyProductPhaseBoardCol,
    company_product_id: number,
    product_task_id: number,
    data?: { company_product_phase_board: CompanyProductPhaseBoard; columns: Columns[] }
  ): Observable<any> | undefined {
    if (
      colOrigin.company_product_phase_board_col_role != null &&
      colDestination.company_product_phase_board_col_role != null &&
      colOrigin.id != colDestination.id
    ) {
      if (
        ['todo', 'test', 'done'].includes(colOrigin.company_product_phase_board_col_role.slug) &&
        colDestination.company_product_phase_board_col_role.slug === 'in-progress'
      ) {
        // ha mogut de todo a progress
        return dialog
          .open(TaskFromTodoToProgressDialogComponent, {
            data: { product_task_board_id: product_task_board_id, company_product_id: company_product_id },
            disableClose: true,
            width: '400px',
          })
          .afterClosed();
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'in-progress' &&
        colDestination.company_product_phase_board_col_role.slug === 'todo'
      ) {
        // torna de in progress a to do
      } else if (colDestination.company_product_phase_board_col_role.slug === 'deadlock') {
        // l'ha posat en deadlock
        return dialog
          .open(TaskToDeadlockDialogComponent, {
            data: {
              product_task_board_id: product_task_board_id,
              company_product_id: company_product_id,
              product_task_id: product_task_id,
              direction: 'in',
            },
            disableClose: true,
            width: '400px',
          })
          .afterClosed();
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'deadlock' &&
        ['in-progress', 'todo', 'under-review'].includes(colDestination.company_product_phase_board_col_role.slug)
      ) {
        // l'ha tret de deadlock
        return dialog
          .open(TaskToDeadlockDialogComponent, {
            data: {
              product_task_board_id: product_task_board_id,
              company_product_id: company_product_id,
              product_task_id: product_task_id,
              direction: 'out',
            },
            disableClose: true,
            width: '400px',
          })
          .afterClosed()
          .pipe(
            switchMap((result1: ProductTaskBoard | undefined): Observable<ProductTaskBoard | undefined> => {
              if (colDestination.company_product_phase_board_col_role.slug === 'in-progress') {
                let secondDialog$: Observable<ProductTaskBoard | undefined> = of(undefined);

                secondDialog$ = dialog
                  .open(TaskFromTodoToProgressDialogComponent, {
                    data: { product_task_board_id: product_task_board_id, company_product_id: company_product_id },
                    disableClose: true,
                    width: '400px',
                  })
                  .afterClosed();

                return secondDialog$.pipe(
                  switchMap((result2: ProductTaskBoard | undefined): Observable<ProductTaskBoard | undefined> => {
                    return of({ ...result1!, ...result2! });
                  })
                );
              }

              return of(result1);
            })
          );
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'in-progress' &&
        colDestination.company_product_phase_board_col_role.slug === 'under-review'
      ) {
        // l'ha posat en under review
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'under-review' &&
        colDestination.company_product_phase_board_col_role.slug === 'in-progress'
      ) {
        // l'ha rechazat
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'under-review' &&
        colDestination.company_product_phase_board_col_role.slug === 'todo'
      ) {
        // l'ha acceptat pero queda feina per fer
      } else if (
        colOrigin.company_product_phase_board_col_role.slug === 'under-review' &&
        ['test', 'done'].includes(colDestination.company_product_phase_board_col_role.slug)
      ) {
        // s'ha acceptat
      } else if (
        ['test', 'done'].includes(colOrigin.company_product_phase_board_col_role.slug) &&
        colDestination.company_product_phase_board_col_role.slug === 'in-progress'
      ) {
        // estava feta pero la tornem a passar a in progress
      } else if (
        ['test', 'done'].includes(colOrigin.company_product_phase_board_col_role.slug) &&
        colDestination.company_product_phase_board_col_role.slug === 'todo'
      ) {
        // estava feta pero la tornem a passar a to do
      }

      return of(null);
    }

    return undefined;
  }

  private findProductTaskBoardOnStructure(id_or_code: number | string): ProductTaskBoardCustom | undefined {
    const data = this.data();
    if (!data) return undefined;
    for (const col of data.columns) {
      for (const task of col.product_task_boards) {
        if ((typeof id_or_code === 'string' && task.product_task.code === id_or_code) || task.id === id_or_code) {
          return task;
        }
      }
    }

    return undefined;
  }

  private findAndUpdateProductTaskBoardOnStructure(updated_product_task_board: ProductTaskBoardCustom): void {
    const data = this.data();
    if (!data) return;
    for (let col_idx = 0; col_idx < data.columns.length; col_idx++) {
      let updated: boolean = false;
      const taskIndex = data.columns[col_idx].product_task_boards.findIndex(
        (task: ProductTaskBoardCustom) => task.id === updated_product_task_board.id
      );
      if (taskIndex !== -1) {
        const task = data.columns[col_idx].product_task_boards[taskIndex];
        if (task.company_product_phase_board_col_id === updated_product_task_board.company_product_phase_board_col_id) {
          data.columns[col_idx].product_task_boards[taskIndex] = updated_product_task_board;
        } else {
          data.columns[col_idx].product_task_boards.splice(taskIndex, 1);
        }
        updated = true;
      }
      if (!updated && data.columns[col_idx].column.id === updated_product_task_board.company_product_phase_board_col_id) {
        data.columns[col_idx].product_task_boards.unshift(updated_product_task_board);
      }
    }
  }

  private createProductTaskBoardOnStructure(created_product_task_board: ProductTaskBoardCustom): void {
    const data = this.data();
    if (!data) return;
    const task_index = created_product_task_board.id;

    data.columns[0].product_task_boards.splice(task_index, 0, created_product_task_board);
  }

  private removeProductTaskBoardFromStructure(id_or_code: number | string): void {
    const data = this.data();
    if (!data) return;
    for (let col_idx = 0; col_idx < data.columns.length; col_idx++) {
      const taskIndex = data.columns[col_idx].product_task_boards.findIndex(
        (task: ProductTaskBoardCustom) =>
          (typeof id_or_code === 'string' && task.product_task.code === id_or_code) || task.id === id_or_code
      );
      if (taskIndex !== -1) {
        data.columns[col_idx].product_task_boards.splice(taskIndex, 1);
        return;
      }
    }
  }

  private filterByMode(ptb: ProductTaskBoard): boolean {
    if (this.mode === 'all') return true;
    else if (this.mode === 'assigned') {
      return ptb.product_task_board_time_budgets.find(ptbtb => ptbtb.assignee_id == this.user?.id) !== undefined;
    } else if (this.mode === 'listening') {
      return ptb.product_task.product_task_listeners.find(listener => listener.id == this.user?.id) !== undefined;
    } else return false;
  }

  public onDragStarted(drag: CdkDrag<ProductTaskBoardCustom>, col: CompanyProductPhaseBoardCol) {
    this.draggingOriginSlug = col.company_product_phase_board_col_role?.slug ?? null;
    const boardId = +drag.element.nativeElement.getAttribute('data-product-task-board-id')!;
    const board = this.findProductTaskBoardOnStructure(boardId) as ProductTaskBoard;
    this.draggingBoard = board;
    this.draggingOriginIsDevPending =
      CompanyProductPhaseBoardDetailComponent.hasPendingDevBudget(board) && this.draggingOriginSlug === 'under-review';

    const data = this.data();
    if (data) {
      for (const column of data.columns) {
        column.column.isBlocked = this.isBlockedColumn(column.column);
      }
    }
  }

  public onDragEnded() {
    this.draggingOriginSlug = null;
    this.draggingBoard = null;
    this.draggingOriginIsDevPending = false;

    const data = this.data();
    if (data) {
      for (const column of data.columns) {
        column.column.isBlocked = false;
      }
    }
  }

  public isBlockedColumn(column: CompanyProductPhaseBoardCol): boolean {
    if (!this.draggingOriginSlug || !this.draggingBoard) return false;

    const dest_slug = column.company_product_phase_board_col_role.slug;

    const would_complete_budgets_on_future_board =
      UtilsService.isCompanyProductPhaseBoardFuture(this.data()?.company_product_phase_board) &&
      UtilsService.columnMoveWouldCompleteBoardBudgets(this.draggingOriginSlug, dest_slug);

    if (would_complete_budgets_on_future_board) {
      return true;
    }

    return this.shouldBlockOrHide(this.draggingBoard, this.draggingOriginSlug, dest_slug);
  }

  public static hasPendingBudget(board: ProductTaskBoard): boolean {
    const pending = board.product_task_board_time_budgets.filter(
      tb =>
        tb.id &&
        tb.completed_by_user_id == null &&
        (tb.budgetable_type === 'App\\Models\\CompanyProductTeam' || (tb.budgetable as WorkingTimeCategory).slug !== 'review-task')
    );
    return pending.length > 0;
  }

  public static hasPendingDevBudget(board: ProductTaskBoard): boolean {
    const active = board.product_task_board_time_budgets.find(tb => tb.id === board.active_product_task_board_time_budget_id);
    if (!active) return false;

    const pending = board.product_task_board_time_budgets.filter(
      tb =>
        tb.id &&
        tb.completed_by_user_id == null &&
        tb.id !== board.active_product_task_board_time_budget_id &&
        (tb.budgetable_type === 'App\\Models\\CompanyProductTeam' || (tb.budgetable as WorkingTimeCategory).slug !== 'review-task')
    );
    return pending.length > 0;
  }

  private shouldBlockOrHide(board: ProductTaskBoard, originSlug: string | null, destSlug: string | null): boolean {
    if (!originSlug) return false;

    switch (originSlug) {
      case 'todo':
        return !['in-progress', 'deadlock', 'todo'].includes(destSlug ?? '');

      case 'in-progress':
        return !['under-review', 'todo', 'deadlock', 'in-progress'].includes(destSlug ?? '');

      case 'deadlock':
        return !['todo', 'in-progress', 'under-review', 'deadlock'].includes(destSlug ?? '');

      case 'under-review':
        if (CompanyProductPhaseBoardDetailComponent.hasPendingDevBudget(board)) {
          return !['in-progress', 'deadlock', 'under-review', 'todo'].includes(destSlug ?? '');
        } else {
          return !['in-progress', 'deadlock', 'under-review', 'test', 'done'].includes(destSlug ?? '');
        }

      case 'test':
        return !['test', 'done'].includes(destSlug ?? '');

      case 'done':
        if (!CompanyProductPhaseBoardDetailComponent.hasPendingBudget(board)) return !['done'].includes(destSlug ?? '');
        else return !['todo'].includes(destSlug ?? '');

      default:
        return false;
    }
  }

  private static async askReasonRejection(dialog: MatDialog, declinedReasons: ProductTaskDeclineReason[]): Promise<number[]> {
    const dialogRef = dialog.open(CheckboxSelectorDialogComponent, {
      width: '400px',
      data: {
        dialog_title: '¿Por qué la estás rechazando?',
        dialog_ok_button: 'Aceptar',
        dialog_cancel_button: 'Cancelar',
        data: declinedReasons.map((msg: ProductTaskDeclineReason) => ({
          value: msg.id,
          textToShow: msg.message,
        })),
      },
    });
    const selectedReasons: number[] = await dialogRef.afterClosed().toPromise();
    return selectedReasons || [];
  }

  private goToTaskFromCurrent(current_task_board: ProductTaskBoardCustom, task_nav_move: TaskNavMove): void {
    const current_column = this.data()?.columns.find(col => col.column.id === current_task_board.company_product_phase_board_col_id);
    if (!current_column) return;
    if (task_nav_move === TaskNavMove.Up || task_nav_move === TaskNavMove.Down) {
      let task_index = current_column.product_task_boards.findIndex(ptb => ptb.id === current_task_board.id);
      task_index += task_nav_move === TaskNavMove.Up ? -1 : 1;
      const task_code = current_column.product_task_boards[task_index].product_task.code;
      this.setRouteParamsAndOpenTask(task_code, task_nav_move);
      return;
    }

    const task_code = this.getCodeOfFirstTaskInColumnsTo(current_column.column, task_nav_move);
    if (task_code !== '') {
      this.setRouteParamsAndOpenTask(task_code, task_nav_move);
    }
  }

  private getTaskNavMoveAbilitiesInCurrentBoard(task_code: string): TaskNavMoveAbilities {
    const task_board: ProductTaskBoardCustom | undefined = this.findProductTaskBoardOnStructure(task_code);
    const abilities: TaskNavMoveAbilities = { up: false, down: false, left: false, right: false };
    if (!task_board) return abilities;

    const current_column = this.data()?.columns.find(col => col.column.id === task_board.company_product_phase_board_col_id);
    if (!current_column) return abilities;

    abilities.up = current_column.product_task_boards[0].id !== task_board.id;
    abilities.down = current_column.product_task_boards[current_column.product_task_boards.length - 1].id !== task_board.id;
    abilities.left = this.canMoveToColumnIn(current_column.column, TaskNavMove.Left);
    abilities.right = this.canMoveToColumnIn(current_column.column, TaskNavMove.Right);

    return abilities;
  }

  private canMoveToColumnIn(
    current_board_col: CompanyProductPhaseBoardCol,
    direction_to_check: TaskNavMove.Left | TaskNavMove.Right
  ): boolean {
    if (!this.data()) return false;
    const total_columns = this.data()!.columns.length;
    const limit_to_check = direction_to_check === TaskNavMove.Left ? 0 : total_columns - 1;
    if (this.data()!.columns[limit_to_check].column.id === current_board_col.id) return false;

    return this.getCodeOfFirstTaskInColumnsTo(current_board_col, direction_to_check) !== '';
  }

  private getCodeOfFirstTaskInColumnsTo(
    current_board_col: CompanyProductPhaseBoardCol,
    direction_to_check: TaskNavMove.Left | TaskNavMove.Right
  ): string {
    const current_index = this.data()!.columns.findIndex(col => col.column.id === current_board_col.id);
    const start_index = direction_to_check === TaskNavMove.Left ? current_index - 1 : current_index + 1;
    const limit_to_check = direction_to_check === TaskNavMove.Left ? -1 : this.data()!.columns.length;
    for (let index = start_index; index != limit_to_check; direction_to_check === TaskNavMove.Left ? index-- : index++) {
      if (this.data()!.columns[index].product_task_boards.length > 0)
        return this.data()!.columns[index].product_task_boards[0].product_task.code;
    }
    return '';
  }

  static fetchDeclineReasons(api: ApiService, working_time_category_id: number | null) {
    if (working_time_category_id == null) working_time_category_id == -1;
    return api.getProductTaskDeclineReasons(working_time_category_id).toPromise();
  }
}

interface ProductTaskBoardCustom extends ProductTaskBoard {
  ro_time_registered: number;
  product_task_board_time_budgets: ProductTaskBoardTimeBudgetCustom[];
  active_product_task_board_time_budget: ProductTaskBoardTimeBudgetCustom | undefined;
  can_drag: boolean;
  can_archive_or_delete: boolean;
}

interface ProductTaskBoardTimeBudgetCustom extends ProductTaskBoardTimeBudget {
  ro_time_registered: number;
}
